import { AfterContentInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { VideoComponentBase } from '../../../../../models/video-component.base.interface';
import { VideoEntity, VideoLibraryEntity, VideoStreamingProviderEntity } from '../../../../../../../meta-data/app-meta-data.service';
import { VideoEvent } from '../../../../../models/video-event.model';
import { VideoEventType } from '../../../../../models/video-event-type.enum';
import { BunnyTimeData } from '../../models/bunny-time-data.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VideoPlayerBaseComponent } from '../../../base/video-player-base.component';
import { DwLoggingService, DwSecurityUserService } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-video-player-bunny',
  template: `
 
   <div style="width:100%" class="video-player-container">
     <div [ngStyle]="videoPlayerStyle" class="video-player-container">
       <iframe id="iframe" #player [src]="videoUrlSafe" class="video-player-container" loading="lazy" style="border:0;top:0;height:100%;width:100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowfullscreen="true"></iframe>
     </div>
   </div>
  `
})
export class VideoPlayerBunnyComponent extends VideoPlayerBaseComponent implements VideoComponentBase, AfterContentInit, OnDestroy {
  videoUrl: string;
  videoUrlSafe: SafeUrl;

  @ViewChild('iframe') playerIframe: HTMLIFrameElement;
  message: string;
  player: any;
  userSeeked: boolean = false;
  lastTimeData: BunnyTimeData;
  ignoreNextStopEvent: boolean;
  seekFurthestTime: boolean;
  videoStartComplete: boolean;
  videoDuration: any;

  playerStats : {
    initComplete: boolean,
    started: number,
    paused: number,
    timeUpdate: number,
    completed : number
  } = {
    initComplete: false,
    started: 0,
    paused: 0,
    timeUpdate: 0,
    completed: 0
  }

  logStats: boolean = true;

  // videoPlayerStyle:any =  {
  //   width : '600px',
  //   height: '400px',
  //   //width:'100%',
  //   // 'min-width': '400px',
  //   // 'min-height': '225px',
  //   'min-width': '350px',
  //   'min-height': '196px',
  //   'max-width': '1200px'
  // }


  videoPlayerStyle: any = {
    width: '100%',
    // 'min-width': '400px',
    // 'min-height': '225px',
    'min-width': '350px',
    'min-height': '196px',
    'max-width': '1200px'
  }

  aspectRatio: number = 16 / 9;

  width: number;
  height: number;
  maxHeight: number;
  finalHeight: number;
  finalWidth: string;
  previousWidth: number;
  videoUrl2: string;

  constructor(dwSecurityUserService: DwSecurityUserService, private sanitizer: DomSanitizer, private hostElementRef: ElementRef, private dwLoggingService: DwLoggingService) {
    super(dwSecurityUserService);
  }

  ngOnDestroy(): void {
    if (!this.logStats) {
      return;
    }

    this.logStats = false;

    this.dwLoggingService.logVerbose(`Bunny.net player stats - ${JSON.stringify(this.playerStats)}`, this.playerStats, true);
  }

  setupVideo(): void {
    super.setupVideo();
    this.setVideoPlayerStyle

    const videoKey = this.video?.VideoKey;
    const videoLibraryKey = this.videoLibrary?.VideoLibraryKey;

    if (!videoKey) {
      return;
    }

    // this didn't look like it will change so didn't make it a configurable option
    const responsive = true;

    //this.videoUrl = this.video?.DirectPlayUrl;

    this.videoUrl = `${this.video?.DirectPlayUrl.replace('/play','/embed')}?autoplay=${this.videoStreamingProvider.AutoPlay}&loop=false&muted=false&preload=${this.videoStreamingProvider.PreloadVideo}&responsive=${responsive}`;

    //this.videoUrl = `https://iframe.mediadelivery.net/embed/${videoLibraryKey}/${videoKey}?autoplay=${this.videoStreamingProvider.AutoPlay}&loop=false&muted=false&preload=${this.videoStreamingProvider.PreloadVideo}&responsive=${responsive}`;

    this.videoUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
  }


  @HostListener('window:resize', ['$event'])
  public reset(event: any): void {
    // re-configure the grid style upon browser resize
    this.setVideoPlayerStyle();
  }


  ngAfterContentInit(): void {
    this.playerIframe = this.hostElementRef?.nativeElement?.children?.iframe;

    if (!this.playerIframe) {
      this.playerIframe = this.hostElementRef?.nativeElement?.firstChild.firstChild.firstChild;
    }

    this.setupPlayer();
  }

  setupPlayer() {
    if (this.player) {
      return;
    }

    if (!this.playerIframe) {
      
      this.dwLoggingService.logWarning('Bunny.net player - Could not find player iframe element');
      return;
    }

    this.setVideoPlayerStyle();

    // set src attribute so player js can find it (it doesn't work with Angular bound src attribute)
    this.playerIframe.src = this.videoUrl;

    const playerJs = (window as any).playerjs;

    if (!playerJs) {
      this.message = 'Could not find playerjs';
      console.warn('Could not find Bunny.Net playerjs for Video Events');

      this.dwLoggingService.logWarning('Bunny.net player - Could not find Bunny.Net playerjs for Video Events');
      return;
    }

    this.player = new playerJs.Player('iframe');

    this.message = 'Player setup'; 

    this.player.on('play', (data) => {
      this.playerStats.started++;

      console.log('play event', data);
   
      this.onVideoEvent(VideoEventType.videoStarted);
    });

    this.player.on('pause', (data) => {
      this.playerStats.paused++;

      if (this.ignoreNextStopEvent) {
        this.ignoreNextStopEvent = false;
        return;
      }

      this.onVideoEvent(VideoEventType.videoPaused);
    });

    this.player.on('ended', (data) => {
      this.playerStats.completed++;

      if (this.ignoreNextStopEvent) {
        this.ignoreNextStopEvent = false;
        return;
      }

      this.onVideoEvent(VideoEventType.videoStopped);
    });

    this.player.on('timeupdate', (timeData: BunnyTimeData) => {
      this.playerStats.timeUpdate++;
      const timeUpdateResult = this.updateCurrentTime(timeData.seconds);

      if (timeUpdateResult.userSeeked) {
        this.player.setCurrentTime(this.furthestWatchedTime);
      }

      this.onVideoEvent(VideoEventType.videoProgress);
    });

    this.player.on("ready", () => this.initVideoPlayer());
  }

  initComplete = false;

  initVideoPlayer() {

    if (this.initComplete) {

      return;
    }


    if (!this.player.isReady) {

      setTimeout(() =>
        this.setupVideoStartOptions(), 100);

      return;
    }

     this.playerStats.initComplete = true;

    this.player.getDuration((duration) => {
      this.videoDuration = duration;

      if (this.videoDuration > 0) {
        this.initComplete = true;
        this.setupVideoStartOptions();
        return;
      }

      setTimeout(() => {
        this.initVideoPlayer();
      }, 100);
    });

  }

  setupVideoStartOptions() {
    if (this.videoStartComplete) {
      return;
    }

    this.videoStartComplete = true;

    if (this.videoStreamingProvider.ContinueFromLastPosition) {
      this.seekFurthestTime = true;

      if (this.furthestWatchedTime >= 0 && this.furthestWatchedTime < Math.round(this.videoDuration)) {
        this.player.setCurrentTime(this.furthestWatchedTime);
      }
    }

    if (this.videoStreamingProvider.AutoPlay) {
      this.player.play();
    }

  }

  mobileWidth = 850;

  setVideoPlayerStyle() {
    if (!this.hostElementRef?.nativeElement) {
      return;
    }
    this.width = this.hostElementRef.nativeElement?.firstChild?.clientWidth;
    const offsetTop: number = this.hostElementRef.nativeElement?.getBoundingClientRect()?.top || 0;

    if (!this.width) {

      setTimeout(() => {
        this.setVideoPlayerStyle();

      }, 50);
      return;
    }

    if (this.previousWidth === this.width) {
      return;
    }

    this.previousWidth = this.width;

    this.height = Math.round(this.width / this.aspectRatio) + 2;

    this.maxHeight = window.innerHeight - offsetTop - 100;

    this.finalHeight = this.height;
    this.finalWidth = '100%';

    if (this.finalHeight > this.maxHeight && this.width > this.mobileWidth) {
      this.finalHeight = this.maxHeight;
      const adjustedWidth = Math.round(this.finalHeight * this.aspectRatio) - 2;

      this.finalWidth = `${adjustedWidth}px`;
    }

    this.videoPlayerStyle = {
      'width': this.finalWidth,
      'min-width': '350px',
      'min-height': '196px',
      height: `${this.finalHeight}px`
    };

    this.videoWidthChanged.emit(this.finalWidth);
  }

}
